<template>
    <div class="index-ad-block-mobile-container">
        <icon-close class="index-ad-block-mobile__close-btn" v-if="showCloseBtn" v-on:click.native="closeBanner" />
        <div v-on:click="openAdLink" class="index-ad-block-mobile" v-bind:style="bgStyle">
            <div class="index-ad-block-mobile__header">
                {{ $t(`ads.${service}.mobile.title`) }}
                <!--<ui-link v-bind:to="{ name: 'advertise' }" class="index-ad-block-mobile__ads-tag" v-on:click.stop>{{ $t('ads.sponsored') }}</ui-link>-->
            </div>
            <!--<button class="index-ad-mobile-button">{{ $t(`ads.${service}.mobile.button`) }}</button>-->
            <div class="index-ad-block-mobile__description" v-html="$t(`ads.${service}.mobile.description`)" />
            <img v-bind:src="bannerUrl" class="index-ad-img-mobile" />
            <img class="index-ad-img-mobile--grid" v-bind:src="maskGridUrl" alt="memhash" />
        </div>
    </div>
</template>

<script>
import bannerUrl from '@img/advertise/thefund/building.png'; // eslint-disable-line
import maskGridUrl from '@img/advertise/mask-grid.png';
import IconClose from '@primer/octicons/build/svg/x-24.svg?inline';

export default {
    props: {
        showCloseBtn: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            maskGridUrl,
            bannerUrl,
            service: 'thefund',
        };
    },

    methods: {
        closeBanner() {
            this.$store.dispatch('closeAd');
        },

        openAdLink() {
            window.open(this.$t(`ads.${this.service}.link`), '_blank');
        },
    },

    components: {
        IconClose,
        // bannerUrl,
    },
};
</script>

<style lang="scss">
.index-ad-block-mobile-container {
    padding: 0 16px;
    box-sizing: border-box;
    width: 100%;
    margin-top: 16px;
}

.index-ad-block-mobile {
    display: block;
    border: 1px solid var(--card-border-color); // default var(--header-border-bottom-color)
    background: linear-gradient(90deg, #1D1D1D 0%, #2E2E2E 100%);
    //font-family: Nunito, Rubik, Roboto, Ubuntu, Arial, sans-serif;
    color: white;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 65px;
    border-radius: 12px;
    box-shadow: 0 0.5rem 1.2rem var(--card-box-shadow-color);
    font-size: 14px;
    overflow: hidden;
    padding: 10px 16px;
    cursor: pointer;

    &__header {
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 6px;
    }

    &__description {
        font-size: 13px;
        max-width: 270px;
        z-index: 100;
        font-family: Rubik, Roboto, Ubuntu, Arial, sans-serif;

        b {
            font-weight: 500;
        }
    }

    &__ads-tag {
        display: inline-block;
        transform: translate(3px, 2px);
        margin-left: 4px;
        font-size: 10px;
        padding: 1px 7px;
        background: var(--card-pill-background);
        border-radius: 10px;
        font-weight: 500;
        text-transform: uppercase;
        background-color: rgba(255, 255, 255, 0.19);
        color: white;
        z-index: 99;
        position: absolute;
        &:hover {
            text-decoration: none;
        }
    }

    &__close-btn {
        position: absolute;
        top: 6px;
        right: 22px;
        cursor: pointer;
        color: white;
        fill: white;

        width: 20px;
        height: 20px;
        background-color: var(--body-light-muted-color);
        border-radius: 15px;
        z-index: 100;
        backdrop-filter: blur(5px);
    }

    &:hover {
        text-decoration: none;
    }
}

.index-ad-img-mobile {
    position: absolute;
    width: 76px;
    top: 2px;
    right: -8px;
    z-index: 9;

    &--grid {
        position: absolute;
        width: auto;
        height: 200px;
        top: 0;
        right: 0;
        z-index: 8;
    }
}

.index-ad-mobile-arrow-right {
    width: auto;
    height: 18px;
    margin: 0 0 -4px -7px;
}

.revo-3d-mobile-logo {
    position: absolute;
    width: 47px;
    height: 47px;
    top: 10px;
    right: 104px;
}

.revo-blockchains-mobile-image {
    position: absolute;
    width: 102px;
    top: 8px;
    right: 2px;
}

.index-ad-mobile-button {
    //position: absolute;
    //bottom: 9px;
    //left: 25px;
    display: block;
    text-align: center;
    background: #fff;
    padding: 3px 12px;
    border-radius: 20px;
    font-size: 12px;
    text-transform: uppercase;
    color: #1E8DFE;
    font-weight: 500;
    font-family: Rubik, Roboto, Ubuntu, Arial, sans-serif;
    cursor: pointer;
    z-index: 10;
}
</style>
